export const GET_AGREEMENTS = 'GET_AGREEMENTS';
export const POST_AGREEMENTS = 'POST_AGREEMENTS';
export const REQUIRED_VERSION = '20231228';
export const TERMS_CONTENT_URL_BASE =
  'https://antaa-public.s3.ap-northeast-1.amazonaws.com/agreements/terms-of-service/terms-of-service-';
export const TERMS_SUMMARY_URL_BASE =
  'https://antaa-public.s3.ap-northeast-1.amazonaws.com/agreements/terms-of-service/summary/terms-of-service-';
